module.exports = __webpack_public_path__ + "img/ring_KITO_HMH.8d0179d5.png";